<template>
  <Dialog
    v-model="dialog"
    icon="fas fa-trash-alt"
    :title="'確認'"
    textNo="いいえ"
    textYes="はい"
    colorTextYes="red--text"
  >
    <template v-slot:content>削除します。よろしいですか。</template>
    <template v-slot:actions>
      <v-btn small color @click="dialog = false">{{$t('CANCEL')}}</v-btn>
      <v-btn
        :loading="loading"
        color="error"
        small
        @click="handleDelete(item.Id)"
      >{{$t('OK')}}</v-btn>
    </template>
  </Dialog>
</template>

<script>
import { deleteExpression } from "@/api/Expression.api";
import Dialog from "@/components/Dialog/Dialog";
export default {
  props: ["item"],
  components: { Dialog },
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  methods: {
    async handleDelete() {
      this.loading = true;
      let params = {
        id: this.item.Id,
        section_id: this.$route.params.section,
      };
      await deleteExpression(params)
        .then(() => {
          this.$emit("resetList");
          this.dialog = false;
        })
        .catch(() => {});
      this.loading = false;
    },
    handleCancel() {
      this.$emit("resetList");
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>